//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CRater from "@/components/CRater";
import CAvatar from "@/components/CAvatar";
import { getUserInfo, setUserInfo, PRODUCTID, removeToken, removeUserInfo } from "@/utils/auth";
import SysUtils from "@/utils/sysUtils";
import NumberUtils from "@/utils/numberUtils";
import UserService from "@/api/userService";

export default {
  data() {
    return {
      star: 0,
      starName: "",
      children: "",
      progress: "", // 进度条
      assessmentProgress: "", // 考核进度
      assessmentInfo: {}, // 考核信息
      stock: 0,
    };
  },
  computed: {
    level: function () {
      return getUserInfo().memberLevel;
    },
    name: function () {
      let userInfo = getUserInfo();
      if (userInfo.phone) {
        return userInfo.phone;
      } else {
        return userInfo.nickName;
      }
    },
    status: function () {
      return getUserInfo().phoneStatus;
    },
    crownIcon: function () {
      if (this.$root.themeType == "yellow") {
        return require("../../assets/theme_yellow/crown.png");
      } else {
        return require("../../assets/theme_black/crown.png");
      }
    },
    zhifuIcon: function () {
      if (this.$root.themeType == "yellow") {
        return require("../../assets/theme_yellow/zhifu.png");
      } else {
        return require("../../assets/theme_black/zhifu.png");
      }
    },
    kucunIcon: function () {
      if (this.$root.themeType == "yellow") {
        return require("../../assets/theme_yellow/kucun.png");
      } else {
        return require("../../assets/theme_black/kucun.png");
      }
    },
    tihuoIcon: function () {
      if (this.$root.themeType == "yellow") {
        return require("../../assets/theme_yellow/tihuo.png");
      } else {
        return require("../../assets/theme_black/tihuo.png");
      }
    },
    dizhiIcon: function () {
      if (this.$root.themeType == "yellow") {
        return require("../../assets/theme_yellow/dizhi.png");
      } else {
        return require("../../assets/theme_black/dizhi.png");
      }
    },
    hetongIcon: function () {
      if (this.$root.themeType == "yellow") {
        return require("../../assets/theme_yellow/hetong.png");
      } else {
        return require("../../assets/theme_black/hetong.png");
      }
    },
  },
  mounted() {
    // 页面初始化获取用户信息
    this.getUserInfo();
  },
  methods: {
    /**
     * 获取用户信息，更新本地用户信息数据
     */
    getUserInfo() {
      UserService.getUserInfo()
        .then((res) => {
          let userInfo = res.data;
          this.star = Number(userInfo.starLevel);
          this.starName = userInfo.starLevelName;
          this.children = userInfo.totalChildren;
          this.progress = NumberUtils.toPercent(userInfo.totalChildren / 30);

          setUserInfo(userInfo);

          this.getStock();
          this.agentExamineCycle();
        })
        .catch((err) => {
          this.$vux.toast.text(err.msg);
        });
    },
    /**
     * 获取用户库存
     */
    getStock() {
      UserService.queryStock(PRODUCTID)
        .then((res) => {
          this.stock = res.data.stock;
        })
        .catch((err) => {
          this.$vux.toast.text(err.msg);
        });
    },
    /**
     * 获取考核信息
     */
    agentExamineCycle() {
      UserService.agentExamineCycle()
        .then((res) => {
          let data = res.data;
          let assessmentProgress = NumberUtils.toPercent(data.extractNum / data.assessmentCriteria);
          let lastNum = data.assessmentCriteria - data.extractNum;
          lastNum = lastNum <= 0 ? 0 : lastNum;

          this.assessmentInfo = {
            ...data,
            assessmentProgress: assessmentProgress,
            lastNum: lastNum,
          };
        })
        .catch((err) => {
          this.$vux.toast.text(err.msg);
        });
    },
    clickOrderList() {
      this.$router.push({
        path: "/orderList",
      });
    },
    clickInventory() {
      this.$router.push({
        path: "/inventory",
      });
    },
    clickDeliveryList() {
      this.$router.push({
        path: "/deliveryList",
      });
    },
    clickAddress() {
      this.$router.push({
        path: "/addressList",
      });
    },
    clickAgreement() {
      let userInfo = getUserInfo();
      if (userInfo) {
        SysUtils.navWeb(userInfo.memberId, userInfo.companyId, this.$root.themeType, true);
      } else {
        this.$vux.toast.text("用户信息失效，请重新登录后再试");
      }
    },
    backHome() {
      this.$router.push({
        path: "/robbing",
      });
    },
    /**
     * 退出操作
     * 清空缓存，保留主题缓存
     * 进入授权页，重新获取code，并进入登录页
     */
    handleQuit() {
      const self = this;
      this.$vux.confirm.show({
        // 组件除show外的属性
        title: "提示",
        content: "是否确认退出？",
        onCancel() {},
        onConfirm() {
          UserService.logout()
            .then((res) => {
              removeToken();
              removeUserInfo();
              sessionStorage.clear();
              // self.$router.push({
              //   path: "/login",
              // });

              self.$router.push({
                path: "/wxAuth",
                query: {
                  scene: "quit",
                },
              });
            })
            .catch((err) => {
              self.$vux.toast.text(err.msg);
            });
        },
      });
    },
  },
  components: {
    CRater,
    CAvatar,
  },
};



// WEBPACK FOOTER //
// ./src/views/user/userCenter.vue